import { Injectable } from '@angular/core';
import { LessonModel, LessonRequest } from '@generativ/much-smarter-models';
import { HttpClient } from '@angular/common/http';

import {catchError} from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ErrorHandlerService } from '../../core/services/error-handler.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class LessonService {

  lesson;
  private lessonUrl = environment.msApiUrl + 'lessons/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService
  ) {
  }

  getLesson(id: number): Observable<LessonModel> {
    return this.http.get<LessonModel>(this.lessonUrl + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  createLesson(lesson: LessonRequest.Create): Observable<LessonModel> {
    return this.http.post<LessonModel>(this.lessonUrl, lesson).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateLesson(id: number, lesson: LessonRequest.Update): Observable<LessonModel> {
    return this.http.patch<LessonModel>(this.lessonUrl + id, lesson).pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
